import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Seo from '../components/Seo'
import { PostNav } from '../components/PostNav'
import { PostView } from '../components/PostView'
import { Card } from '../components/Card'
import styled from 'styled-components'
import { SeriesSwitcher } from '../components/SeriesSwitcher'
import { getImage } from 'gatsby-plugin-image'
const PostWrapper = styled(Card)``

const PostPage = ({ pageContext, data }) => {
  const post = data.markdownRemark
  const { previous, next } = data
  const { author, seoImage } = post.frontmatter

  const previousPost = previous
    ? { title: previous.frontmatter.title, slug: previous.fields.slug }
    : undefined
  const nextPost = next
    ? { title: next.frontmatter.title, slug: next.fields.slug }
    : undefined

  return (
    <Layout>
      <Seo
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        image={
          seoImage
            ? getImage(seoImage).images.fallback.src
            : post.fields.seoImageFallback
        }
        isArticle
      />

      <PostWrapper>
        <PostView
          title={post.frontmatter.title}
          tags={post.frontmatter.tags}
          author={author}
          featuredImage={post.frontmatter.featuredImage}
          date={post.frontmatter.date}
          content={post.html}
          tableOfContents={post.tableOfContents}
        />
        {pageContext.series && data.series.nodes.length > 1 && (
          <>
            <h2>Các bài viết cùng chủ đề</h2>
            <SeriesSwitcher
              title={pageContext.series}
              series={data.series.nodes}
              currentSlug={post.fields.slug}
            />
          </>
        )}
        <PostNav previousPost={previousPost} nextPost={nextPost} />
      </PostWrapper>
    </Layout>
  )
}

export default PostPage

export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String!
    $previousPostId: String
    $nextPostId: String
    $series: String
  ) {
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      html
      tableOfContents(maxDepth: 2)
      frontmatter {
        ...postFields
        featuredImage {
          childImageSharp {
            gatsbyImageData(width: 800, placeholder: BLURRED)
          }
        }
        seoImage: featuredImage {
          childImageSharp {
            gatsbyImageData(
              width: 1200
              height: 630
              formats: PNG
              layout: FIXED
            )
          }
        }
        author {
          ...authorFields
        }
      }
      fields {
        slug
        seoImageFallback
      }
    }
    series: allMarkdownRemark(
      filter: { frontmatter: { series: { eq: $series } } }
      sort: { frontmatter: { date: ASC } }
    ) {
      nodes {
        fields {
          slug
        }
        frontmatter {
          title
        }
      }
    }
    previous: markdownRemark(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: markdownRemark(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`
